module.exports = __webpack_public_path__ + "d3f1bde3e0085164709536deef3bbb6e.svg";